import React from 'react';

function Servicehead(){
    return(
        <>
                     <section className="page-header" style={{ backgroundImage: 'url(assets/img/page-banner2.gif)', backgroundSize: 'cover', backgroundPosition: 'center' }}>

    <div className="container">
      <div className="page-header-info">
      
        <h2>
     
          <span>IT Solution</span>
        </h2>
      
      </div>
    </div>
  </section>
        
        </>
    )
}
export default Servicehead;